//import React,{ useState, useEffect } from "react";
import {
  Button,
  IconButton,
  TextField,
  Typography,
  Box,
  Tooltip,
} from "@mui/material";
import {
  Grid,
  InputLabel,
  Select,
  MenuItem,
  FormControl,
} from "@material-ui/core";
import * as FileSaver from 'file-saver';
import EditIcon from "@mui/icons-material/Edit";
import { DataGrid } from "@mui/x-data-grid";
import DeleteIcon from "@mui/icons-material/Delete";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import DownloadIcon from "@mui/icons-material/Download";
import React, { useState, useEffect,useCallback } from "react";
import "../Z-Code-Master/z-code-master.css";
import SnackbarCustom from "../../../components/Snackbar/Snackbar";
import { useSelector ,useDispatch} from "react-redux";
import {
  SearchZcode,
  getZcodeTableData,
  addZcodeData,
  updateZcodeData,
  deleteZcodeData,getZcode,ExportZCode
} from "../../../redux/API/api_zCodeMaster";
import ZCodePopup from "./z-code-dialog";
import { BootstrapInput } from "../../../Utilities/utility";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import {zcodes} from "../../../redux/Actions/actions";
import * as XLSX from "xlsx";


export default function ZCodeMaster() {
  const dispatch = useDispatch();

  const columns = [
    { field: "zcode", headerName: "ZCode", width: 200, sortable: true },
    { field: "zCodeDescription", headerName: "ZCode Description", width: 300 },
    { field: "status", headerName: "Status", width: 300 },

    { field: "isActive", headerName: "Is Active", width: 400,
      renderCell:(params)=>(<span className={
      `status-indicator ${params.value ? "green" : "grey"}`
    }
    
    
    ></span>
   
    ) 
  },
    {
      field: "action",
      headerName: "Actions",
      flex: 0.5,
      sortable: false,
      width: "100px",

      renderCell: (params) => (
        <div>
          <IconButton
            color="primary"
            onClick={() => handleEditZCode(params.row)}
          >
            <EditIcon style={{ cursor: "pointer" }} />
            
          </IconButton>
          <IconButton onClick={() => handleDelete(params.row)}>
            <DeleteIcon />
          </IconButton>
        </div>
      ),
    },
  ];
  const [selected, setSelected] = useState([]);
  const [initialRows, setInitialRows] = useState([]);
  const [zCodeFilter, setZcodeFilter] = useState();
  const [zCodeData, setZCodeData] = useState([]);
  const [editUser, setEditUser] = useState(false);
  const [open, setOpen] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [alertType, setAlertType] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [rows, setRows] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [isLoader, setIsLoader] = useState(false);
  const UID = useSelector((state) => state.saveUserIdReducer);
  const userdetails = useSelector(
    (state) => state.storeUserDetailsReducer.userData
  );
  const siteToken = useSelector((state) => state.saveTokenReducer);
  const azureToken = useSelector((state) => state.saveAzureTokenReducer);
  const [openForDelete, setOpenForDelete] = useState(false);
  const [deleteUser, setDeleteUser] = useState([]);

  const handleSnackOpen = (text, type) => {
    setSnackMessage(text);
    setAlertType(type);
    setOpen(true);
  };

  useEffect(() => {
    setZcodeFilter(0);
    console.log('zcode on dropdown',zCodeData);
    console.log('row',rows);
    console.log('selected',selected);
    getZcodeDropDownValue();
    getTableData();
    //const filterData = zCodeData ? rows.filter((item)=>item.code===zCodeData):rows
    //getZcodeMaster();
    console.log("gezcodefilter", zCodeFilter);
  }, []);

  function getTableData() {
    setIsLoader(true);
    getZcodeTableData(
      siteToken,
      azureToken.token,
      UID.id,
      userdetails.userEmail,
      userdetails.roleName,
      userdetails.gid,
      userdetails.roleId
    )
      .then((response) => {
        setInitialRows(response);
        console.log("rows", rows);
        setRows(response);
        //const filterData = zCodeData ? rows.filter((item)=>item.zcode===zCodeData):rows
        //setSelected(filterData);
        setIsLoader(false);
      })
      .catch((error) => {
        console.log("Error: " + error, "error");
        setIsLoader(false);
      });
  }
  

  function getZcodeDropDownValue() {
    setIsLoader(true);
    getZcode(
      siteToken,
      azureToken.token,
      UID.id,
      userdetails.userEmail,
      userdetails.gid,
      userdetails.roleName,
      userdetails.roleId
    )
      .then((response) => {
        console.log("zcode", response);
        dispatch(zcodes(response));
        setZCodeData(response);
        setIsLoader(false);
      })
      .catch((error) => {
        console.log("Error: " + error, "error");
        setIsLoader(false);
      });
  }

  const handleSearch = (event) => {
    const value = event.target.value.toLowerCase();
    setSearchText(value);
    const filteredRows = initialRows.filter((row) =>
      Object.values(row).some((field) =>
      field ? field.toString().toLowerCase().includes(value) : ""
      )
    );
    setRows(filteredRows);
  };

  

  const zCodeFilterChange = (e) => {
    
    console.log(zCodeFilter);
    setZcodeFilter(e.target.value);
  };

  // const exportToExcel = () => {
  //   let ExcelData = [];
  //   console.log('export file',ExcelData)
   
  //   if(!rows || rows.length===0){
  //     console.error("No data available for export.");
  //     return;
  //   }else{
  //   for (let i = 0; i < rows?.length; i++) {
  //     let input = {};
  //     input.SrNo = i + 1;
  //     input.ZCode = rows[i]?.zcode;
  //     input.ZCodeDescription = rows[i]?.zCodeDescription;
  //     input.Status = rows[i]?.status;

  //     ExcelData.push(input);
  //   }
  // }
  //   const worksheet = XLSX.utils.json_to_sheet(ExcelData);
  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(workbook, worksheet, "Z-code Master");
  //   XLSX.writeFile(workbook, "z-code master.xlsx");
  // };

  const clearSearch = () => {
    setSearchText("");
    setRows(initialRows);
  };

  const handleSearChange = () => {
  console.log(zCodeFilter);
 
  const formData  = new FormData();
  formData.append("zcodeid",zCodeFilter)

    setIsLoader(true);
    SearchZcode(
      siteToken,
      azureToken.token,
      UID.id,
      userdetails.userEmail,
      userdetails.gid,
      userdetails.roleName,
      userdetails.roleId,
      formData
      //newTableData
    )
      .then((response) => {
        if (response) {
          handleSnackOpen(response.responseMsg, "success");
          setIsLoader(false);
          setRows(response);
         // getTableData();
        } else {
          handleSnackOpen(response.responseMsg, "error");
          setIsLoader(false);
        }
      })
      .catch((error) => {
       handleSnackOpen("Exception : " + error, "error");
        setIsLoader(false);
     });
   };
// opening add dialog when  user clicks on add button
  const handleAddZCode = useCallback(() => {
    setEditUser(null);
    setOpenDialog(true);
  }, []);

  const handleSaveZcode = (newUser) => {
    setOpenDialog(false);
    handleRowAdd(newUser);
  };

   // when user click on delete icon opening dilog box and setting user
   const handleDelete = (zcodedata) => {
    console.log(zcodedata);
    setOpenForDelete(true);
    setDeleteUser(zcodedata);
  };
  const handleEditZCode = (editZcode) => {
    setOpenDialog(true);
    setEditUser(editZcode);
  };

  const handleUpdateZCode = (newuser) => {
    setOpenDialog(false);
    handleRowUpdate(newuser);
  };

 
  const handleRowAdd = (newTableData) => {
    setIsLoader(true);
    addZcodeData(
      siteToken,
      azureToken.token,
      UID.id,
      userdetails.userEmail,
      userdetails.gid,
      userdetails.roleName,
      userdetails.roleId,
      newTableData
    )
      .then((response) => {
        if (response.response) {
          handleSnackOpen(response.responseMsg, "success");
          setIsLoader(false);
          getTableData();
        } else {
          handleSnackOpen(response.responseMsg, "error");
          setIsLoader(false);
        }
      })
      .catch((error) => {
        handleSnackOpen("Exception : " + error, "error");
        setIsLoader(false);
      });
  };
  const handleRowUpdate = (prevData) => {
    console.log(prevData.zcode);
    setOpenDialog(false);
    setIsLoader(true);
    updateZcodeData(
      siteToken,
      azureToken.token,
      UID.id,
      userdetails.userEmail,
      userdetails.gid,
      userdetails.roleName,
      userdetails.roleId,
      prevData
    )
    .then((response) => {
      if (response.response) {
        handleSnackOpen(response.responseMsg, "success");
        setIsLoader(false);
        getTableData();
      } else {
        handleSnackOpen(response.responseMsg, "error");
        setIsLoader(false);
      }
    })
    .catch((error) => {
      handleSnackOpen("Exception : " + error, "error");
      setIsLoader(false);
    });
  };

 
  const handleRowDelete = () => {
    console.log(deleteUser.categoryId);
    setIsLoader(true);
    setOpenForDelete(false);
    


    deleteZcodeData(
      siteToken,
      azureToken.token,
      UID.id,
      userdetails.userEmail,
      userdetails.gid,
      userdetails.roleName,
      userdetails.roleId,
      deleteUser.categoryId
      
      
    )
      .then((response) => {
        if (response.response) {
          handleSnackOpen(response.responseMsg, "success");
          setIsLoader(false);
          getTableData();
        } else {
          handleSnackOpen(response.responseMsg, "error");
          setIsLoader(false);
        }
      })
      .catch((error) => {
        handleSnackOpen("Exception : " + error, "error");
        setIsLoader(false);
      });
  };

  function exportToExcel() {
    setIsLoader(true);
   let categoryId =0;
    ExportZCode(
      siteToken,
      azureToken.token,
      UID.id,
      userdetails.userEmail,
      userdetails.gid,
      userdetails.roleName,
      userdetails.roleId,
      categoryId)
        .then((response) => {
            if (response.status === 200) {
                if (response.data.byteLength <= 200) {
                    setIsLoader(false);
                    handleSnackOpen();
                    setSnackMessage("No Records are Found ");
                    setAlertType("success");
                } else {
                    var blob = new Blob([response.data], {
                        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    });
                    FileSaver.saveAs(blob, "Z code Report.xlsx");
                    setIsLoader(false);
                    handleSnackOpen();
                    setSnackMessage("Z code Report Downloaded");
                    setAlertType("success");
                }
            } else {
                setIsLoader(false);
                handleSnackOpen();
                setSnackMessage("Report download failed");
                setAlertType("error");
            }
        })
        .catch((error) => {
            setIsLoader(false);
            handleSnackOpen();
            setSnackMessage("Error: ", error);
            setAlertType("error");
        });
}








  // closing delete dialog box
  
  
  
  
  
  const handleCloseforDelete = () => {
    setOpenForDelete(false);
    setDeleteUser([]);
  };

  // snackbar close
  const handleClose = (e) => {
    setOpen(false);
  };

  const handleReset =(e)=>{
    setZcodeFilter('');
    setRows(initialRows);
  };

 
  return (
    <>
      <Box sx={{ padding: "10px", border: "1px solid #ccc" }}>
        <Typography variant="h5" gutterBottom>
          Z-Code Master
        </Typography>
        <div>
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth>
              <InputLabel shrink htmlFor="bootstrap-input">
                ZCode
              </InputLabel>
              <Select
                id=""
                name=""
                displayEmpty
                fullWidth
                value={zCodeFilter || ''}
                onChange={zCodeFilterChange}
                input={<BootstrapInput />}
              >
                <MenuItem value="" disabled>
                  --Select Value--
                </MenuItem>
                {zCodeData?.map((item) => (
                  <MenuItem key={item.zcodeid} value={item.zcodeid}>
                    {item.zcode}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Button className="btn"
            variant="contained"
            disabled={!zCodeData}
            onClick={handleSearChange}
            style={{
             // fontFamily: "SiemensSans-Bold, sans-serif",
              position: "relative",
              left: "421px",
              bottom: "38px",
              //backgroundColor: "rgb(0, 138, 166)",
            }}
            
          >
            Search
          </Button>

          <Button className="btn"
            variant="outlined"
            onClick={handleReset}
            style={{
              //fontFamily: "SiemensSans-Bold, sans-serif",
              position: "relative",
              left: "440px",
             // backgroundColor: " rgb(0, 138, 166)",
              bottom: "38px",
              color: "white",
            }}
            
          >
            Reset
          </Button>
        </div>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            padding: "10px",
          }}
        >
          <SearchIcon color="action" />
          <TextField
            variant="standard"
            placeholder="Search"
            value={searchText}
            onChange={handleSearch}
            sx={{ marginLeft: "5px", width: "200px", width: "200px" }}
          />
          <IconButton onClick={clearSearch} size="small">
            <ClearIcon fontSize="small" />
          </IconButton>
          <Tooltip title="Download excel" arrow disableInteractive>
            <IconButton onClick={()=>exportToExcel()} size="small"> 
              <DownloadIcon />
            </IconButton>
          </Tooltip>
          <div>
            <Button className="btn"
              variant="contained"
              style={{
                fontFamily: "SiemensSans-Bold, sans-serif",
                //backgroundColor: "#008aa6",
              }}
              onClick={handleAddZCode}
            >
              Add
            </Button>
            <ZCodePopup
              open={openDialog}
              onClose={() => setOpenDialog(false)}
              onSave={handleSaveZcode}
              onUpdate={handleUpdateZCode}
              userToEdit={{ editUser }}
            />
          </div>
        </Box>
        <div style={{ height: 530, width: "100%" }}>
          <DataGrid
            rows={rows}
            columns={columns}
            getRowId={(row) => row.categoryId}
            pageSize={4}
            rowsPerPageOptions={[4]}
            disableRowSelectionOnClick
            localeText={{
              noRowsLabel: "No Matching Records Found!",
            }}
            loading={isLoader}
            sx={{
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#d3d3d3",
                fontWeight: "500",
                fontSize: "13px",
                color: "black",
                lineHeight: "1.5rem",
              },
              "& .MuiDataGrid-columnHeader": { backgroundColor: "#d3d3d3" },

              "& .MuiDataGrid-cell": { textAlign: "left", fontSize: "12px",display:"flex",alignItems:"center" },
              "& .MuiDataGrid-footerContainer": {
                //border: "1px solid #000",
                fontSize: "12px",
              },
            }}
          />
          <>
          <SnackbarCustom
            open={open}
            message={snackMessage}
            alertType={alertType}
            handleClose={handleClose}
          />
        </>
        <Dialog
          open={openForDelete}
          onClose={handleCloseforDelete}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to delete the Zcode?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleCloseforDelete}
              className="pt-button--secondary"
            >
              Cancel
            </Button>
            <Button
              onClick={() => handleRowDelete()}
              className="pt-button--primary"
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>



        </div>
        
      </Box>
    </>
  );
}
